import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AcctContext } from "../../utility/useReduce/userNameReduce";
import { ReactComponent as Avatar } from "../../assets/images/img-avatar.svg"
import { ReactComponent as Build } from "../../assets/images/img-build.svg"
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import PrimeDialog from "../dialog/PrimeDialog";
import PrimeConfirmDialog from "../dialog/PrimeConfirmDialog";
import { handleSuccessMessage, MessageContext } from "../../store/messageStore";
import { checkLoading, SystemLoading } from "../../store/loadingStore";
import CusContractTable from "../../pages/companyBinding/component/CusContractTable";
import { checkDpSuccess, handleSessionClear } from "../../utility/service/tool-service";
import { updateComEffectiveType } from "../../utility/service/dataRegister-service";
import { revocationToken } from "../../utility/service/dgr-service";
import { updateUserLoginRecord } from "../../utility/service/api-service";

export const UserAvatarButton = ({ type }) => {
    const { t } = useTranslation();
    const [state, dispatchUser] = useContext(AcctContext); //使用者資訊
    const topbarUserInfoMenu = useRef(null);
    const navigate = useNavigate();
    const [levelUpDialog, setLevelUpDialog] = useState(false);
    const [, loading] = useContext(SystemLoading);
    const [, dispatch] = useContext(MessageContext); //訊息視窗
    const [contractDialog, setContractDialog] = useState(false);
    const [contractList, setContractList] = useState([])
    const [userName, setUserName] = useState('');
    
    const topbarUserInfoItems = [
        {
            label: t('progressCheck'),
            icon: "pi pi-list",
            visible: state?.companiesContractData !== null,
            command: () => { setContractDialog(true); },
        },
        {
            label: t('upgradeMember'),
            icon: "pi pi-gift",
            visible: state?.isAdmin === 'Y' && state?.effectiveType === '1' && state?.companiesContractData === null,
            command: () => { setLevelUpDialog(true); }
        },
        {
            label: t('button.bulletin'),
            icon: "pi pi-bell",
            command: () => { handleGoNoticePage(); }
        },
        { separator: true, visible: type === "topBar", },
        {
            label: t('logout'),
            icon: "pi pi-sign-out",
            visible: type === "topBar",
            command: () => { handleLogout() }
        },
    ]
    const confirmLevelUp = () => {
        checkLoading(loading);
        updateComEffectiveType({
            companySeq: state.companySeq,
            reqType: '0'
        })
            .then((res) => {
                if (checkDpSuccess(res)) {
                    let comData = res?.data?.RespBody
                    dispatchUser({
                        type: 'COM_CONTRACT_DATA', payload: {
                            companiesContractData:
                            {
                                companiesContractId: comData?.companiesContractId,
                                upgradeDateTime: comData?.upgradeDateTime,
                                upgradeUser: comData?.upgradeUser,
                                contractDateTime: comData?.contractDateTime,
                                contractUser: comData?.contractUser,
                                invoiceNo: comData?.invoiceNo,
                                invoiceDateTime: comData?.invoiceDateTime,
                                invoiceUser: comData?.invoiceUser
                            }
                        }
                    })
                    setLevelUpDialog(false);
                    handleSuccessMessage(dispatch, t('applySuccess'));


                }
            }).finally((fin) => {
                checkLoading(loading, false);
            })
    }
    const handleLogout = async() => {
        //註銷token access_token refresh_token
        await updateUserLoginRecord({eventType:"LOGOUT"});
        await revocationToken('access_token')
            .then((res) => {
                if (res?.status === 200) {
                    dispatchUser({ type: 'CLEAR_INFO' });
                    return revocationToken('refresh_token');
                }
            })
            .then((res) => {
                if (res?.status === 200) {
                    handleSessionClear();//不要將loadTheme刪除 系統設定的主題色
                    navigate("/login");
                }
            })

    }
    const handleGoNoticePage = () => {
        navigate("/management");
        dispatchUser({ type: 'CURRENT_FUNCID', payload: '' });
    }
    const GoogleAvatar = () => {
        return (
            <img className="img-user"
                src={JSON.parse(sessionStorage?.getItem('decode_token'))?.['picture']}
                alt="" />
        )
    }
    const CustomAvatar = () => {
        switch (state.companyType) {
            case 'A':

                return (<Avatar className="img-avatar" />)
            case 'B':

                return (<Build className="img-avatar" />)

            default:
                return (<Avatar className="img-avatar" />)
        }

    }
    const contractData = (effectiveType) => {
        switch (effectiveType) {
            case "0": //正式
                return (
                    <span style={{ color: type === "sideBar" ? "white" : "var(--primary-color)" }}
                        className="contract-str">{t('formal')}</span>
                )
            case "1": //試用
                return (
                    <span style={{ color: type === "sideBar" ? "white" : "var(--gray-400)" }}
                        className="contract-str">{t('trial')}</span>
                )
            default:
                return null;
        }
    }
    useEffect(() => {
        // const _userName = JSON.parse(sessionStorage?.getItem('decode_token'))?.['name']
        // if (_userName) setUserName(_userName);
        setUserName(state.userName);
        if (state?.companiesContractData !== null) {
            setContractList([
                {
                    status: t('upgradeRequest'),
                    time: state?.companiesContractData?.upgradeDateTime,
                    personnel: state?.companiesContractData?.upgradeUser
                },
                {
                    status: t('contractUpdate'),
                    time: state?.companiesContractData?.contractDateTime,
                    personnel: state?.companiesContractData?.contractUser
                },
                {
                    status: t('invoiceUpdate'),
                    time: state?.companiesContractData?.invoiceDateTime,
                    personnel: state?.companiesContractData?.invoiceUser
                }
            ])
        }
    }, [state])
    const userButtonType = (type) => {
        switch (type) {
            case 'topBar':
                return (
                    <Button text className="user-avatar-button"
                        onClick={(event) => topbarUserInfoMenu.current.toggle(event)}>
                        {sessionStorage?.getItem('idp_type') === 'GOOGLE' ?
                            (<GoogleAvatar />) : (<CustomAvatar />)
                        }
                        <span>{userName}</span>
                        {contractData(state?.effectiveType)}
                        <i className="pi pi-angle-down"></i>
                    </Button>
                )
            case 'sideBar':

                return (
                    <>
                        {sessionStorage?.getItem('idp_type') === 'GOOGLE' ?
                            (<GoogleAvatar />) : (<CustomAvatar />)
                        }

                        <Button text className="user-avatar-button"
                            onClick={(event) => topbarUserInfoMenu.current.toggle(event)}>
                            <span style={{ color: "white" }}>{userName}</span>
                            {contractData(state?.effectiveType)}
                            <i className="pi pi-angle-down" style={{ color: "white" }}></i>
                        </Button>
                    </>
                )

            default:
                break;
        }
    }
    return (
        <>
            {userButtonType(type)}
            <Menu
                // style={{left:"31px"}}
                className={type === "sideBar" && 'center'}
                popup
                ref={topbarUserInfoMenu}
                model={topbarUserInfoItems} />
            <PrimeConfirmDialog
                visible={levelUpDialog}
                onClose={() => { setLevelUpDialog(false) }}
                onConfirm={() => { confirmLevelUp(); }}
                title={t('upgradeMember')}
                bodyTemplate={<>
                    <label htmlFor="">
                        {t('upgradeInfo')}
                    </label>
                </>}
            />
            <PrimeDialog
                visible={contractDialog}
                isShowConfBtn={false}
                onClose={() => { setContractDialog(false); }}
                title={t('progressCheck')}
                bodyTemplate={
                    <CusContractTable contractList={contractList} />
                }
            />
        </>
    )
}